// Simple portfolio grid that receives items as props. Used in onboarding flows.
// See PortfolioGridNew for self-contained variant with data fetching and infinite scroll.
import React from 'react'
import { Avatar } from '../../elements'
import { Pagination, PortfolioItem } from '../../gql/types'
import { Pagination as PaginationComponent } from '../Pagination'
import { VideoPlayer } from '../VideoPlayer'
import { VideoPlayerProvider } from '../VideoPlayer/Provider'
import { DeletePortfolioItemButton } from '../DeletePortfolioItemButton'

export interface PortfolioGridProps {
  items: PortfolioItem[]
  pagination?: Pagination
  setPage?(page: number): void
  isFullScreen?: boolean
  isDeleteAvailable?: boolean
}

export const PortfolioGrid: React.FC<PortfolioGridProps> = ({
  items,
  pagination,
  setPage,
  isFullScreen,
  isDeleteAvailable,
}) => {
  let gridClassName = 'grid grid-cols-2 gap-x-6 gap-y-6 '
  if (isFullScreen) {
    gridClassName += `md:grid-cols-2 lg:grid-cols-3`
  }

  if (!isFullScreen) {
    gridClassName += `grid-cols-2`
  }

  return (
    <div className='@container px-4 max-w-7xl'>
      <ul className={gridClassName}>
        <VideoPlayerProvider>
          {items?.map((item: PortfolioItem) => (
            <div key={item.id} className='group'>
              <div className='relative isolate flex flex-col justify-end shadow-sm shadow-black/20 dark:shadow-white/20 overflow-hidden rounded-2xl bg-gray-900 aspect-[0.7]'>
                <VideoPlayer
                  src={item.video.url}
                  poster={item?.thumbnail?.url}
                  className='absolute inset-0 -z-10 h-full w-full'
                  controls
                />
                <div className='absolute left-2 top-2 gap-y-1 overflow-hidden text-sm leading-6 text-white'>
                  <div className='flex gap-x-2 items-center'>
                    <Avatar
                      type='user'
                      size='xxs'
                      src={item.creator.avatar?.url}
                      alt={item.creator?.firstName}
                    />
                    {item.creator?.firstName}
                  </div>
                </div>
                {isDeleteAvailable && (
                  <div className='absolute right-2 top-2 gap-y-1 overflow-hidden text-sm leading-6 text-white'>
                    <DeletePortfolioItemButton portfolioId={item.id} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </VideoPlayerProvider>
      </ul>
      {pagination && (
        <PaginationComponent
          pagination={pagination}
          setPage={setPage}
          className='px-0 sm:px-0 mt-4'
        />
      )}
    </div>
  )
}
